module.exports = __webpack_public_path__ + "img/1517266891.db8f1dde.jpg";